import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton';
import LoadingSpinner from './components/LoadingSpinner';
import { useProSidebar } from 'react-pro-sidebar';
import Objects from './pages/Objects';
import Support from './pages/Support';
import Devices from './pages/Devices';
import LoginYandex from './pages/LoginYandex';
import AccountDeletionPolicy from './pages/Delete';
import User from './pages/User';
import Registration from './pages/Registration';
import Integrations from './pages/Integrations';
import Dashboard from './pages/Dashboard';
import Authorization from './pages/Authorization';
import Verify from './pages/Verify';
import Reset from './pages/Reset';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Events from './pages/Events';
import Payments from './pages/Payments';

import PersonalData from './components/PersonalData';
import TermsOfUse from './components/TermsOfUse';
import { useDevicesStore, useObjectsStore, useSettingsStore, useUserStore } from './stores';
import Feedback from './pages/Feedback';
import Instructions from './pages/Instructions';
import SupportChat from './pages/SupportChat';
import useHandleRedirectAuth from './hooks/useHandleRedirectAuth';
import CustomSideBar from './features/SideBar/SideBar';
import useAppInit from './hooks/useAppInit';
import { cn } from './utils/cn';

let setAuthorizedEvent = () => {};

const App = () => {
  const { toggleSidebar, broken } = useProSidebar();
  const { darkToggle } = useSettingsStore();
  const { setAuthorized, authorized } = useUserStore();
  const { objectsExist } = useObjectsStore();
  const { devicesExist } = useDevicesStore();
  const { loading } = useAppInit();

  useHandleRedirectAuth();

  setAuthorizedEvent = (status) => {
    setAuthorized(status);
  };

  const getDefaultRoute = () => {
    if (objectsExist) {
      return devicesExist ? <Dashboard /> : <Devices />;
    } else {
      return <Objects />;
    }
  };

  const ContentLayout = ({ title, children }) => {
    return (
      <div className="min-h-screen bg-gray-200 flex justify-center items-center py-10">
        <div className="w-full max-w-4xl mx-4 bg-white rounded-3xl p-5 shadow-lg overflow-auto pt-5 pb-5">
          <h1 className="text-2xl font-bold text-center mb-4">{title}</h1>
          {children}
        </div>
      </div>
    );
  };

  const PrivacyPolicy = () => {
    return (
      <ContentLayout title="Политика в отношении обработки персональных данных">
        <PersonalData />
      </ContentLayout>
    );
  };

  const Terms = () => {
    return (
      <ContentLayout title="Пользовательское соглашение">
        <TermsOfUse />
      </ContentLayout>
    );
  };

  return (
    <>
      <main className={cn(authorized ? 'flex h-screen' : 'min-h-screen', darkToggle && 'dark')}>
        {!loading ? (
          <>
            {authorized ? (
              <>
                <CustomSideBar />
                <div className="w-full overflow-y-scroll overflow-x-hidden">
                  {broken && (
                    <div className="sticky top-0 m-0 w-full bg-[#FFFFFF] shadow-2xl">
                      <IconButton onClick={() => toggleSidebar()}>
                        <MenuRoundedIcon />
                      </IconButton>
                    </div>
                  )}
                  <Routes>
                    <Route path="/objects" element={<Objects />} />
                    <Route path="/support" element={<Support />} />
                    {process.env.REACT_APP_FEATURE_SUPPORT_CHAT === 'true' && (
                      <Route path="/support-chat" element={<SupportChat />} />
                    )}
                    {objectsExist && <Route path="/devices" element={<Devices />} />}
                    <Route path="/user" element={<User />} />
                    <Route path="/registration" element={<Registration />} />
                    {objectsExist && devicesExist && <Route path="/integrations" element={<Integrations />} />}
                    {objectsExist && devicesExist && <Route path="/events" element={<Events />} />}
                    <Route path="/payments" element={<Payments />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/" element={getDefaultRoute()} />

                    <Route path="*" element={<Navigate to={objectsExist ? 'devices' : 'objects'} />} />

                    <Route path="/verify" element={<Verify userLoggedIn={true} />} />
                    <Route path="/resetpass" element={<Reset />} />
                    <Route path="/yandex" element={<LoginYandex />} />
                    <Route path="/delete" element={<AccountDeletionPolicy />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/instruction" element={<Instructions />} />
                    {/*<Route path="/integrationForm" element={<IntegrationForm />} />*/}
                  </Routes>
                </div>
              </>
            ) : (
              <Routes>
                <Route path="*" element={<Authorization />} />
                <Route path="/verify" element={<Verify userLoggedIn={false}></Verify>} />
                <Route path="/resetpass" element={<Reset />} />
                <Route path="/yandex" element={<LoginYandex />} />
                <Route path="/delete" element={<AccountDeletionPolicy />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/instruction" element={<Instructions />} />
              </Routes>
            )}
          </>
        ) : (
          <>
            <div className="flex min-h-screen p-1 w-full overflow-y-scroll overflow-x-hidden items-center justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
              <LoadingSpinner error={[]} loading={true} />
            </div>
          </>
        )}
      </main>
      <ToastContainer />
    </>
  );
};

export { setAuthorizedEvent };
export default App;
